import { render, staticRenderFns } from "./EntidadeControleCampo.vue?vue&type=template&id=9320dc5a"
import script from "./EntidadeControleCampo.vue?vue&type=script&lang=js"
export * from "./EntidadeControleCampo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports